module.exports = __webpack_public_path__ + "static/media/loading-gif.b6f121db.gif";